<script>
import Layout from '@layouts/main'
import api from '@utils/api'

export default {
  name: 'Password',
  components: {
    Layout,
  },
  data() {
    return {
      valid: true,
      current_password: '',
      new_password: '',
      password_confirm: '',
      passwordChangeLoading: false,
      tryingToChangePassword: false,
    }
  },
  computed: {
    currentPasswordRules() {
      return [value => !!value || this.$i18n.t('validation__password_required')]
    },
    newPasswordRules() {
      return [
        value => {
          if (
            !value ||
            !/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(
              value
            )
          ) {
            return this.$i18n.t('validation__password_rules')
          }
          if (value === this.current_password) {
            return this.$i18n.t('validation__same_password')
          }
          return true
        },
      ]
    },
    confirmPasswordRules() {
      return [
        value => {
          if (!value) {
            return this.$i18n.t('validation__password_required')
          }
          if (value !== this.new_password) {
            return this.$i18n.t('validation__not_same_password')
          }
          return true
        },
      ]
    },
  },

  methods: {
    getCurrentUser() {
      return this.$store.state.auth.user
    },
    tryToChangePassword() {
      if (!this.$refs.passwordForm.validate()) {
        this.valid = false
        this.tryingToChangePassword = false
        return
      }
      this.tryingToChangePassword = true
      return this.changePassword()
    },
    changePassword() {
      this.passwordChangeLoading = true
      const user = this.getCurrentUser()
      api
        .updateSubItem('user', user.sub, 'changepassword', {
          currentPassword: this.current_password,
          newPassword: this.new_password,
        })
        .then(response => {
          if (response) {
            this.$store.commit('notifications/ADD', {
              type: 'success',
              message: `${this.$t(response)}`,
            })
            this.$router.go(-1)
          }
          this.passwordChangeLoading = false
        })
    },
  },
}
</script>

<template>
  <Layout>
    <v-layout wrap>
      <v-flex lg4>
        <v-form
          ref="passwordForm"
          v-model="valid"
          lazy-validation
        >
          <v-text-field
            v-model="current_password"
            :rules="currentPasswordRules"
            :label="$t('label__current_password')"
            type="password"
            required
          />
          <v-text-field
            v-model="new_password"
            :rules="newPasswordRules"
            :label="$t('label__new_password')"
            type="password"
            required
          />
          <v-text-field
            v-model="password_confirm"
            :rules="confirmPasswordRules"
            :label="$t('label__confirm_password')"
            type="password"
            required
          />
        </v-form>
        <v-btn
          :loading="passwordChangeLoading"
          :disabled="passwordChangeLoading || !valid"
          color="primary"
          type="submit"
          @click="tryToChangePassword()"
        >
          {{ $t('buttons__update') }}
        </v-btn>
    </v-flex></v-layout>
  </Layout>
</template>
